// Models
import { OutputConfigViewModel } from "../models/output-config-view.model"

export namespace OutputConfigActions {
    export class SetAll {
        static readonly type = '[Output Config] Set Channels'
        constructor(public configs: OutputConfigViewModel[]) { }
    }
}